import { haversine } from './geo';
import type { Place, Ride, SavedPlace } from './types';

export type RecentPlace = { place: Place; at: string };

/**
 * Where the rider has been dropped lately, newest first, one entry per spot (within 150 m), leaving out saved
 * places (they have their own chips/cards) and the current pickup. From the rider's own trip history only.
 */
export function recentDrops(rides: Ride[], opts: { saved?: SavedPlace[]; pickup?: Place | null; limit?: number } = {}): RecentPlace[] {
  const out: RecentPlace[] = [];
  const near = (a: Place, b: { lat: number; lng: number }) => haversine(a, b) < 150;
  const sorted = [...rides].filter((r) => r.status === 'COMPLETED').sort((a, b) => Date.parse(b.requestedAt) - Date.parse(a.requestedAt));
  for (const r of sorted) {
    const p = r.drop;
    if (out.some((x) => near(x.place, p))) continue;
    if (opts.saved?.some((s) => near(p, s))) continue;
    if (opts.pickup && near(p, opts.pickup)) continue;
    out.push({ place: p, at: r.completedAt ?? r.requestedAt });
    if (out.length >= (opts.limit ?? 5)) break;
  }
  return out;
}
